import { useState, useEffect, useCallback } from "react";
import { useIsElectron } from "../../hooks/useElectron";
import { UpdateChannelModal } from "./updateChannel.component";

/**
 * Global gate component that listens for Ctrl+Shift+U
 * and opens the update channel management modal.
 * Only active when running inside Electron.
 */
export function UpdateChannelGate() {
  const isElectron = useIsElectron();
  const [isOpen, setIsOpen] = useState(false);

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    if (event.ctrlKey && event.shiftKey && event.key === 'U') {
      event.preventDefault();
      setIsOpen((prev) => !prev);
    }
  }, []);

  useEffect(() => {
    if (!isElectron) return;

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isElectron, handleKeyDown]);

  if (!isElectron) return null;

  return <UpdateChannelModal isOpen={isOpen} onClose={() => setIsOpen(false)} />;
}
